export type RangeFilter = [number, number];

export const isRangeFilter = (value: unknown): value is RangeFilter => {
  if (!Array.isArray(value) || value.length !== 2) return false;
  return value.every(item => typeof item === 'number');
};
